import { quintOut } from 'svelte/easing';
import { crossfade } from 'svelte/transition';

   const container = {
        hidden: {

            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.5,
            },
        },

        show: {
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.5,
            },
        },
    }



const [send, receive] = crossfade({
		duration: d => Math.sqrt(d * 200),

		fallback(node, params) {
			const style = getComputedStyle(node);
			const transform = style.transform === 'none' ? '' : style.transform;

			return {
				duration: 600,
				easing: quintOut,
				css: t => `
					transform: ${transform} scale(${t});
					opacity: ${t}
				`
			};
		}
	});

  const itemA = {
      show: { 
          opacity: 1, 
          scale: 1.4,
          x: 80,
          transition : {
            duration: 0.5,
              ease: "cubicInOut",
          }
        },
        hidden: { opacity: 0, x: -200, scale: 1.4 },
    }

  const itemC = {
      show: { 
          opacity: 1, 
          scale: 1,
          y: 0,
          transition : {
            duration: 0.5,
              ease: "cubicInOut",
          }
        },
        hidden: { 
          opacity: 0, 
          y: 15, 
          scale: 1,
          transition : {
            duration: 0.2,
              ease: "cubicInOut",
          }

        },
    }

  const apayment = {
      show: { 
          opacity: 1, 
          scale: 1,
          color: "#81FFD1",
          y: 0,
          transition : {
            duration: 0.5,
              ease: "cubicInOut",
          }
        },
        hidden: { 
          opacity: 0, 
          y: 15, 
          scale: 1,
          transition : {
            duration: 0.2,
              ease: "cubicInOut",
          }

        },
    }

  const itemR = {
      show: { 
          opacity: 1, 
          scale: 1,
          y: 0,
          transition : {
            duration: 0.5,
              ease: "cubicInOut",
          }
        },
        hidden: { 
          opacity: 0, 
          y: 0, 
          scale: 1,
          transition : {
            duration: 0.2,
              ease: "cubicInOut",
          }

        },
    }


  const itemB = {
      show: { 
          opacity: 1, 
          rotate: 0,
          x: 0,
          transition : {
            duration: 0.5,
              ease: "cubicInOut",
          }
        },
        hidden: { opacity: 0, x: -200, rotate: -5 },
    }


  const itemM = {
      show: { 
          opacity: 1, 
          rotate: 0,
          x: 0,
          y: 0,
          transition : {
            duration: 0.5,
              ease: "cubicInOut",
          }
        },
    hidden: { opacity: 0, y: 20, x: -20, rotate: -5 },
    }

export {container, itemA, itemB, itemC, send, receive, apayment, itemM}
